import { c as _c } from "react/compiler-runtime";
import { ALREADY_IN_TEAM_MESSAGE } from "@src/constants/team-constants";
import { useAppDispatch } from "@store/store-helper";
import { updateMany } from "@store/table/table-slice";
import { useEffect } from "react";
/** Whether the member is in the team already, according to the teams loaded for the members */
function isInTeam(teamIdsByMember, member, teamId) {
  return !!teamId && !!teamIdsByMember.get(member.identity)?.has(teamId);
}

/**
 * Marks the selected members who are in the picked team already as not allowed, so that the bulk
 * dialog lists them with the reason but leaves them out of the requests, like other bulk actions
 * do with the members they skip.
 *
 * @returns the members that are not in the picked team yet
 */
export function useMarkMembersInTeam(t0) {
  const $ = _c(14);
  const {
    members,
    teamIdsByMember,
    teamId,
    isEnabled
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== isEnabled || $[2] !== members || $[3] !== teamId || $[4] !== teamIdsByMember) {
    t1 = () => {
      if (!isEnabled) {
        return;
      }
      dispatch(updateMany(members.map(member => ({
        id: member.identity,
        changes: isInTeam(teamIdsByMember, member, teamId) ? {
          status: "not-allowed",
          message: ALREADY_IN_TEAM_MESSAGE
        } : {
          status: "idle",
          message: ""
        }
      }))));
    };
    t2 = [dispatch, isEnabled, members, teamId, teamIdsByMember];
    $[0] = dispatch;
    $[1] = isEnabled;
    $[2] = members;
    $[3] = teamId;
    $[4] = teamIdsByMember;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== members || $[8] !== teamId || $[9] !== teamIdsByMember) {
    let t4;
    if ($[11] !== teamId || $[12] !== teamIdsByMember) {
      t4 = member_0 => !isInTeam(teamIdsByMember, member_0, teamId);
      $[11] = teamId;
      $[12] = teamIdsByMember;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t3 = members.filter(t4);
    $[7] = members;
    $[8] = teamId;
    $[9] = teamIdsByMember;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}